import { isValid, parseISO } from "date-fns";
import { FinancialAccountType } from "@common/types/financialAccount";
import {
    CLOSE_TEMPLATE_REVIEW_FIELDS,
    CloseTemplateReviewField,
} from "@common/types/closeTemplateReviewField";

export function readCloseTemplateMonths(
    viewConfig: object | null,
): number | null {
    if (
        viewConfig === null ||
        !("numberOfMonthsToShowBeforeCurrentClosePeriods" in viewConfig)
    ) {
        return null;
    }
    const months = viewConfig.numberOfMonthsToShowBeforeCurrentClosePeriods;
    return typeof months === "number" ? months : null;
}

export function readCloseTemplateStickyViewType(
    viewConfig: object | null,
): "sticky" | "dynamic" {
    if (viewConfig === null || !("stickyViewType" in viewConfig)) {
        return "sticky";
    }
    return viewConfig.stickyViewType === "dynamic" ? "dynamic" : "sticky";
}

export function readCloseTemplateReviewFields(
    viewConfig: object | null,
): CloseTemplateReviewField[] {
    if (viewConfig === null || !("reviewFields" in viewConfig)) {
        return [];
    }
    const fields = viewConfig.reviewFields;
    if (!Array.isArray(fields)) {
        return [];
    }
    return fields.filter((field): field is CloseTemplateReviewField =>
        CLOSE_TEMPLATE_REVIEW_FIELDS.some((allowed) => allowed === field),
    );
}

export function readDocumentRetrievalAccountType(
    viewConfig: object | null,
): FinancialAccountType | null {
    if (viewConfig === null || !("financialAccountType" in viewConfig)) {
        return null;
    }
    const accountType = viewConfig.financialAccountType;
    if (accountType == null) {
        return null;
    }
    for (const allowed of Object.values(FinancialAccountType)) {
        if (allowed === accountType) {
            return allowed;
        }
    }
    return null;
}

function readOwnString(
    viewConfig: object,
    field: "startDateOverride" | "endDateOverride",
): string | undefined {
    if (field === "startDateOverride") {
        if (!("startDateOverride" in viewConfig)) {
            return undefined;
        }
        return typeof viewConfig.startDateOverride === "string"
            ? viewConfig.startDateOverride
            : undefined;
    }
    if (!("endDateOverride" in viewConfig)) {
        return undefined;
    }
    return typeof viewConfig.endDateOverride === "string"
        ? viewConfig.endDateOverride
        : undefined;
}

export function readDocumentRetrievalDateOverride(
    viewConfig: object | null,
    field: "startDateOverride" | "endDateOverride",
): string | undefined {
    if (viewConfig === null) {
        return undefined;
    }
    const value = readOwnString(viewConfig, field);
    if (value === undefined || !isValid(parseISO(value))) {
        return undefined;
    }
    return value;
}
